var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDelete = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "54px",
    height: "32px",
    viewBox: "0 0 54 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CNC---Cuisine",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PIN",
    transform: "translate(-1611.000000, -849.000000)",
    fill: "#5F7081",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(1056.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(231.000000, 420.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(297.899992, 391.499990)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Delete_1020895",
    transform: "translate(26.099999, 37.799999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.0115721,11.0054141 L42.7123032,1.82174089 C41.4427244,0.646605564 39.7976542,0 38.0690008,0 L6.82596478,0 C3.06408568,0 0.00189961914,3.02061633 0,6.73344422 L0.00126641276,24.7665549 C0.00126641276,28.4793828 3.06155285,31.4999992 6.82913082,31.4999992 L38.0753329,31.4999992 C38.0753329,31.4999992 38.0753329,31.4999992 38.0759661,31.4999992 C39.7900558,31.4999992 41.4351259,30.8540183 42.7452299,29.6432729 L52.0134717,20.4983335 C54.6628072,17.881299 54.662174,13.6224486 52.0115721,11.0054141 Z M49.7738208,18.2911282 L40.5442046,27.3992079 C39.8609749,28.030195 38.983984,28.3769255 38.0753329,28.3769255 L6.82343196,28.3769255 C4.84149599,28.3769255 3.16729832,26.7238643 3.16729832,24.7671797 L3.1660319,6.7346937 C3.16666511,4.7773843 4.8427624,3.12432312 6.82913082,3.12432312 L38.0810317,3.12432312 C38.9909493,3.12432312 39.8660405,3.47105364 40.5093782,4.06518107 L49.7719211,13.2144936 C51.1903034,14.6132857 51.1903034,16.8917113 49.7738208,18.2911282 Z M32.8849402,7.46126594 C32.2662975,6.85089528 31.2645651,6.85089528 30.6465556,7.46126594 L24.4841911,13.5412325 L18.3218266,7.46126594 C17.703184,6.85089528 16.7014515,6.85089528 16.0834421,7.46126594 C15.4654326,8.0716366 15.4647994,9.05997477 16.0834421,9.66972069 L22.2451734,15.750312 L16.0828089,21.8302785 C15.4641662,22.4406491 15.4641662,23.4289873 16.0828089,24.0387332 C16.3918136,24.3442309 16.7970657,24.4966674 17.2016845,24.4966674 C17.6063034,24.4966674 18.0115555,24.3442309 18.3211934,24.039358 L24.4835579,17.9593914 L30.6459224,24.039358 C30.9555603,24.3442309 31.3608124,24.4966674 31.7654313,24.4966674 C32.1700502,24.4966674 32.5753023,24.3442309 32.8849402,24.039358 C33.5035828,23.4289873 33.5035828,22.4406491 32.8849402,21.8309032 L26.7219425,15.750312 L32.884307,9.67034543 C33.5029496,9.05997477 33.5029496,8.0716366 32.8849402,7.46126594 Z",
    id: "Shape",
    transform: "translate(26.999999, 15.750000) scale(-1, 1) translate(-26.999999, -15.750000) "
  })))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDelete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delete.91bdcc3ef00e476a9d3656e665c9a0f3.svg";